import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { logger } from "utils/logger";
import { randomString } from "utils/randomString";
import { useTranslation } from "react-i18next";

const DropdownMui: FC<Props> = ({
  list,
  onChange,
  defaultValue,
  className = "",
  label,
  placeholder,
  allowNull = false,
  disabled = false,
  clearAfterChoose = false,
  variant = "filled",
  hideBorder = false,
  nullName,
  labelPosition = "top",
  menuZIndex,
}) => {
  const { t } = useTranslation();
  const resolvedNullName = nullName ?? t("common.none");
  const [value, setValue] = useState<string | number | null>("");

  // useEffect(() => {
  //   if (defaultValue) {
  //     setValue(list.find((box) => box.value === defaultValue)?.name ?? "");
  //     return;
  //   }
  //   if (disabled) return;

  //   if (list?.[0] && !allowNull) {
  //     setValue(list[0].name);
  //     return;
  //   }
  //   setValue("");
  //   // setValue(allowNull ? '' : list?.[0]?.name ?? '');
  // }, []);

  useEffect(() => {
    if (defaultValue !== null && defaultValue !== -1 && list?.length > 0) {
      logger.log("Validate dropdown value");
      const itm = list.find(
        (box) =>
          box.value === defaultValue || box.value === Number(defaultValue),
      );

      if (!itm) {
        logger.log("Setting empty value");
        setValue("");
      } else {
        setValue(itm.value);
      }
    }
  }, [defaultValue, list]);

  const handleChange = (event: SelectChangeEvent) => {
    const toSelect = list.find(
      (x) =>
        x.value === event.target.value ||
        x.value === Number(event.target.value),
    );
    logger.log("Dropdown changed: ", event.target.value, toSelect);
    setValue(event.target.value);
    onChange(toSelect);

    if (clearAfterChoose) {
      setValue("");
    }
  };

  // const [multiSelect, setMultiSelect] = useState<IDropdownObject[]>([]);
  // const clear = () => {
  //   setValue(null);
  //   onChange();
  // };

  // const handleMultiChange = () => {
  //   onChange(multiSelect);
  //   setValue(null);
  //   setMultiSelect([]);
  // };

  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      {labelPosition === "start" && (
        <div className={styles.lbl}>
          <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel>
        </div>
      )}
      <div className={styles.grow}>
        <FormControl
          variant={variant}
          size="small"
          sx={{
            m: 0,
            minWidth: 60,
            flexGrow: 1,
            backgroundColor: "transparent",
          }}
          hiddenLabel={!label}
        >
          {label && labelPosition === "top" && (
            <InputLabel id="demo-simple-select-filled-label">
              {label}
            </InputLabel>
          )}
          <Select
            labelId="demo-simple-select-filled-label"
            value={value}
            label={label}
            placeholder={placeholder}
            displayEmpty={true}
            onChange={handleChange}
            readOnly={disabled}
            disableUnderline={hideBorder}
            MenuProps={{
              style: { borderRadius: "8px" },
              ...(menuZIndex !== undefined ? { sx: { zIndex: menuZIndex } } : {}),
            }}
            renderValue={(option) => {
              if (!list) {
                return resolvedNullName;
              }
              const itm = list.find((x) => x.value === option);
              if (
                (itm == null || itm?.value === 0 || itm?.value === "") &&
                !label
              ) {
                return resolvedNullName;
              }

              if (!itm) {
                return null;
              }

              return `${itm?.name}`;
            }}
            inputProps={{
              sx: {
                "&:focus": { background: "none" },
                padding: variant === "standard" ? "0" : undefined,
              },
            }}
          >
            {allowNull && (
              <MenuItem className={styles.menuItem} value="">
                {t("common.none")}
              </MenuItem>
            )}
            {list.map((i) => (
              <MenuItem
                className={styles.menuItem}
                value={i.value}
                key={"itm" + randomString() + i.value}
              >
                <div className={styles.name}>
                  {i.Icon && (
                    <div className={styles.icon}>
                      <i.Icon />
                    </div>
                  )}
                  {i.name}
                </div>
                {i.AdditionalInfo && i.AdditionalInfo}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default DropdownMui;
